var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Apply-Slot" },
    [
      _vm._t("default"),
      _c("ApplyButton", {
        attrs: { applyButton: _vm.value, buttonShowType: _vm.buttonShowType },
        on: {
          refreshButton: _vm.refreshButton,
          saveData: _vm.saveData,
          maskShow: function ($event) {
            _vm.maskShow = false
          },
        },
      }),
      _c("div", {
        class:
          (_vm.value.status == 1 ||
            _vm.value.status == 2 ||
            _vm.value.status == 4) &&
          _vm.maskShow
            ? "Mask-True"
            : "",
        attrs: { id: "Mask" },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }